// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "pro.assure",
    name: "Assure",
    homepage: "https://www.assure.pro",
    image_id: "64db7104-c8b7-44ea-e102-11ce87124200",
    app: {
        browser: null,
        ios: "http://itunes.apple.com/app/id1604825026",
        android: "https://play.google.com/store/apps/details?id=com.neuxs.assure",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "assure://",
        universal: "https://www.assure.pro/Official",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map